<form [formGroup]="form">
  <div class="form-group">
    <label for="new-password" class="form-label">New Password</label>
    <div class="password-field position-relative">
      <input
        type="password"
        formControlName="password"
        #newPassField
        class="form-control"
        id="new-password"
      />
      <img
        #newPassToggle
        src="./assets/images/eye-slash.svg"
        id="toggler"
        (click)="showHidePassword(newPassField, newPassToggle)"
        alt="eye-slash"
      />
    </div>
    <app-form-errors
      [color]="'danger'"
      [form]="form"
      [control]="form.controls['password']"
    >
    </app-form-errors>
  </div>
  <div class="form-group">
    <label for="confirm-new-password" class="form-label"
      >Confirm New Password</label
    >
    <div class="password-field position-relative">
      <input
        formControlName="password_confirmation"
        type="password"
        #confNewPassField
        class="form-control"
        id="confirm-new-password"
      />
      <img
        #confNewPassToggle
        src="./assets/images/eye-slash.svg"
        id="toggler"
        (click)="showHidePassword(confNewPassField, confNewPassToggle)"
        alt="eye-slash"
      />
    </div>
    <app-form-errors [control]="form.controls['password_confirmation']">
    </app-form-errors>
  </div>
  <div class="footer">
    <button (click)="dynamicDialogRef.close()" class="cancel-btn">
      Cancel
    </button>
    <button
      [disabled]="!form.valid"
      (click)="handleUpdatePassword()"
      class="custom-btn"
    >
      Update
      <i *ngIf="isSubmitLoading" class="fa-spin fas fa-spinner ms-2"></i>
    </button>
  </div>
</form>
